


















import { Component, Vue, Watch, Inject, Prop } from 'vue-property-decorator';

@Component({})
export default class SendButton extends Vue {
  @Prop({ default: 'enrichment.send' }) public text!: string;
  @Prop({ default: false }) public loading!: boolean;
  @Prop({ default: false }) public disabled!: boolean;
  @Prop() public whiteMode!: boolean;
}
